export const DESIRED_STYLE_OPTIONS = {
  ELEGANT: 'elegant',
  SUSTAINABLE_DESIGN: 'sustainable design',
  CURVES_AND_ORGANIC_SHAPES: 'curves and organic shapes',
  RETRO_AND_VINTAGE: 'retro and vintage',
  MINIMALIST: 'minimalist',
  INDUSTRIAL: 'industrial',
  SCANDINAVIAN: 'scandinavian',
  RUSTIC: 'rustic',
  CONTEMPORARY: 'contemporary',
  MID_CENTURY_MODERN: 'mid-century modern',
  FRENCH_COUNTRY: 'french country',
  COASTAL: 'coastal',
  ART_DECO: 'art deco',
  BOHO_CHIC: 'boho chic',
  URBAN_MODERN: 'urban modern',
  MEDITERRANEAN: 'mediterranean',
  MOROCCAN: 'moroccan',
  VICTORIAN: 'victorian',
} as const;
type DesiredStyleOptionKey = keyof typeof DESIRED_STYLE_OPTIONS;
export type TYPE_DESIRED_STYLE_OPTIONS =
  | (typeof DESIRED_STYLE_OPTIONS)[DesiredStyleOptionKey]
  | undefined;

export const desiredStyleOptions = [
  { value: DESIRED_STYLE_OPTIONS.ELEGANT, image: 'default-imagerendering-style_Electical' }, // TODO: Correct image, as soon as we have it
  {
    value: DESIRED_STYLE_OPTIONS.SUSTAINABLE_DESIGN,
    image: 'default-imagerendering-style_SustainableDesign',
  },
  {
    value: DESIRED_STYLE_OPTIONS.CURVES_AND_ORGANIC_SHAPES,
    image: 'default-imagerendering-style_CurvesAndOrganic',
  },
  {
    value: DESIRED_STYLE_OPTIONS.RETRO_AND_VINTAGE,
    image: 'default-imagerendering-style_RetroAndVintage',
  },
  { value: DESIRED_STYLE_OPTIONS.MINIMALIST, image: 'default-imagerendering-style_Minimalist' },
  { value: DESIRED_STYLE_OPTIONS.INDUSTRIAL, image: 'default-imagerendering-style_Industrial' },
  { value: DESIRED_STYLE_OPTIONS.SCANDINAVIAN, image: 'default-imagerendering-style_Scandinavian' },
  { value: DESIRED_STYLE_OPTIONS.RUSTIC, image: 'default-imagerendering-style_Rustic' },
  { value: DESIRED_STYLE_OPTIONS.CONTEMPORARY, image: 'default-imagerendering-style_Contemporary' },
  {
    value: DESIRED_STYLE_OPTIONS.MID_CENTURY_MODERN,
    image: 'default-imagerendering-style_MidCerntury',
  },
  {
    value: DESIRED_STYLE_OPTIONS.FRENCH_COUNTRY,
    image: 'default-imagerendering-style_FrenchCountry',
  },
  { value: DESIRED_STYLE_OPTIONS.COASTAL, image: 'default-imagerendering-style_Coastal' },
  { value: DESIRED_STYLE_OPTIONS.ART_DECO, image: 'default-imagerendering-style_ArtDeco' },
  { value: DESIRED_STYLE_OPTIONS.BOHO_CHIC, image: 'default-imagerendering-style_BohoChic' },
  { value: DESIRED_STYLE_OPTIONS.URBAN_MODERN, image: 'default-imagerendering-style_UrbanModern' },
  {
    value: DESIRED_STYLE_OPTIONS.MEDITERRANEAN,
    image: 'default-imagerendering-style_Mediterranean',
  },
  { value: DESIRED_STYLE_OPTIONS.MOROCCAN, image: 'default-imagerendering-style_Moroccan' },
  { value: DESIRED_STYLE_OPTIONS.VICTORIAN, image: 'default-imagerendering-style_Victorian' },
];
